export default __webpack_public_path__ + "static/media/Ballroll_00340.5693ddc2.png";